import React from 'react';
import styled from 'styled-components';
import Text from './ui/Text';

/*
 * original svg source:
 * https://github.com/n3r4zzurr0/svg-spinners/blob/abfa05c49acf005b8b1e0ef8eb25a67a7057eb20/svg-css/ring-resize.svg
 */

type SpinnerVariant = 'dark' | 'light';
type SpinnerProps = { size?: number; variant?: SpinnerVariant };

// Ensure spinner only uses efficient animations, which only need compositing rather than layout and paint.
// I.e. limit animation properties to transform and opacity.
const Spinner = styled.div<{ stroke: string }>`
  & {
    contain: strict;
    display: inline-block;
  }
  &:after {
    content: ' ';
    width: 100%;
    height: 100%;
    display: block;
    border-width: 3px;
    border-radius: 50%;
    border-style: solid;
    animation: rotate 0.7s linear infinite;
    border-color: ${(p) => p.stroke || '#fff'} transparent;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const LoadingSpinner = (props: SpinnerProps): JSX.Element => {
  const size = props.size ?? 24;
  const variant: SpinnerVariant = props.variant ?? 'dark';
  return (
    <Spinner
      style={{ width: size, height: size }}
      stroke={variant === 'dark' ? '#3077d1' : '#ffffff'}
    />
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingOverlay = ({
  message,
}: {
  message?: React.ReactNode;
}): JSX.Element => (
  <Overlay>
    <LoadingSpinner variant="dark" size={48} />
    {message && <Text color="neutral.white_50">{message}</Text>}
  </Overlay>
);

export default LoadingSpinner;
